import axios from 'axios'

//HostURL = "https://ezsign.gis.tw/WebAPI/API/";
//開發環境使用
// const HostURL = "/api"; 
// const HostURL2 = "/mail";
// const HostURL3 = "/test";

//正機使用
const HostURL = "https://ezsign.gis.tw/WebAPI/API";
const HostURL2 = "https://ezsign.gis.tw/nchc1006event/api/API";

const RegisterRequest = axios.create({
    baseURL: HostURL + "/Register",
});

const KeyRequest = axios.create({
    baseURL: HostURL + "/Key",
});

const MailRequest = axios.create({
    baseURL: HostURL2 + "/Default",
});

const CalPerRequest = axios.create({
    baseURL: HostURL2 + "/Default",
});

const LogRequest = axios.create({
    baseURL: HostURL2 + "/Default",
});

export const apiGetOpen2= (Token,data) => RegisterRequest.post(`/GetOpen2?Token=${Token}&AT_ID=${data}`);

export const apiCheckRegister = data => RegisterRequest.post(`/CheckRegister?AT_ID=AT20210826172150069&RG_Email=${data}`);

export const apiGetAT_ID = data => RegisterRequest.post(`/GetAT_ID2?Token=${data}`);

export const apiNewRegister = (token,data) => RegisterRequest.post(`/NewRegister?Token=${token}&strJson=${encodeURIComponent(JSON.stringify(data))}`);

export const apiGetKey = data => KeyRequest.post(`/getAuthority2?US_ID=FBFBhVSkbMSntwgwgKrIwNglURw5zeejydI%2fC%2fVTwdo%3d`,data);

export const apiGetToken = data => KeyRequest.post(`/GetToken2?key=${data}&OZ_ID=3FQlpd3BRMIDkg9Ql72vwL9kEUX2E9Zz4tSgPghTpBkTvcAsuKuLADUVC3Z%2fnwPH&AT_ID=3HmhH6ivvhExV6rrBqDHW9%2b4B2jDF%2fK3jbs8vPzg%2f9sTvcAsuKuLADUVC3Z%2fnwPH`);

export const apiGetMailToken = data => MailRequest.post(`/Token`,data);

export const apiSendMail = data => MailRequest.post(`/SendMail`,data);

export const apiCalPerRequest = data => CalPerRequest.post(`/CalPerson`,data);

export const apiGetPerRequest = data => CalPerRequest.post(`/GetPerson`,data);

export const apiSetLogRequest = data => LogRequest.post(`/SetLog`,data);

export const apiGetSession1Count = data => LogRequest.post(`/GetSession1Count`,data);

export const apiGetSession2Count = data => LogRequest.post(`/GetSession2Count`,data);

export const apiGetSession3Count = data => LogRequest.post(`/GetSession3Count`,data);

export const apiGetSession4Count = data => LogRequest.post(`/GetSession4Count`,data);

export const apiGetSession5Count = data => LogRequest.post(`/GetSession5Count`,data);

export const apiGetSession6Count = data => LogRequest.post(`/GetSession6Count`,data);